module.exports = __webpack_public_path__ + "static/img/p-15.de306c6.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/p-15.png
// module id = vHQT
// module chunks = 0